document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const isOpen = nav.hasAttribute('data-open');
  if (isOpen) {
    nav.removeAttribute('data-open');
    nav.style.display = '';
  } else {
    nav.setAttribute('data-open', '');
    nav.style.display = 'flex';
    nav.style.position = 'absolute';
    nav.style.left = '20px';
    nav.style.right = '20px';
    nav.style.top = '74px';
    nav.style.padding = '20px';
    nav.style.flexDirection = 'column';
    nav.style.background = '#06111f';
    nav.style.border = '1px solid rgba(135,160,190,.2)';
    nav.style.borderRadius = '12px';
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    if (slides.length <= 1) return;

    const dotsContainer = slider.querySelector('[data-hero-dots]');
    const autoplayEnabled = slider.dataset.autoplay === 'true';
    const intervalMs = Math.max(parseInt(slider.dataset.interval, 10) || 6000, 3000);

    let currentIndex = 0;
    let autoplayTimer = null;

    function showSlide(index) {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.hero-slider__dot').forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === currentIndex);
          dot.setAttribute('aria-current', dotIndex === currentIndex ? 'true' : 'false');
        });
      }
    }

    function stopAutoplay() {
      if (autoplayTimer !== null) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || document.hidden) return;

      autoplayTimer = window.setInterval(function () {
        showSlide(currentIndex + 1);
      }, intervalMs);
    }

    if (dotsContainer) {
      dotsContainer.innerHTML = '';

      slides.forEach(function (_, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-slider__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Afficher l’image ' + (index + 1));
        dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');

        dot.addEventListener('click', function () {
          showSlide(index);
          startAutoplay();
        });

        dotsContainer.appendChild(dot);
      });
    }

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    showSlide(0);
    startAutoplay();
  });
});

// Centre de support FsStudioFrance v1.1.6
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fsf-support]').forEach(function (support) {
    var accordion = support.querySelector('[data-fsf-accordion]');
    if (accordion) {
      accordion.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          accordion.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    }

    var search = support.querySelector('[data-fsf-faq-search]');
    var noResults = support.querySelector('[data-fsf-no-results]');
    if (search) {
      search.addEventListener('input', function () {
        var query = search.value.trim().toLowerCase();
        var visible = 0;

        support.querySelectorAll('[data-fsf-faq-item]').forEach(function (item) {
          var text = item.textContent.toLowerCase();
          var match = !query || text.indexOf(query) !== -1;
          item.hidden = !match;
          if (match) visible += 1;
        });

        if (noResults) noResults.hidden = visible !== 0;
      });
    }
  });
});


// FsStudioFrance v1.1.7 — loupe FAQ et galerie
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fsf-support]').forEach(function (support) {
    var input = support.querySelector('[data-fsf-faq-search]');
    var button = support.querySelector('[data-fsf-search-button]');
    if (button && input) {
      button.addEventListener('click', function () {
        input.focus();
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }
  });

  document.querySelectorAll('[data-fsf-gallery]').forEach(function (gallery) {
    var lightbox = gallery.querySelector('[data-gallery-lightbox]');
    var content = gallery.querySelector('[data-gallery-lightbox-content]');
    var title = gallery.querySelector('[data-gallery-lightbox-title]');

    gallery.querySelectorAll('[data-gallery-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-filter]').forEach(function (b) { b.classList.remove('is-active'); });
        button.classList.add('is-active');
        var filter = button.getAttribute('data-gallery-filter');
        gallery.querySelectorAll('[data-gallery-item]').forEach(function (item) {
          item.hidden = filter !== 'all' && item.getAttribute('data-gallery-item') !== filter;
        });
      });
    });

    function openLightbox(markup, label) {
      if (!lightbox || !content) return;
      content.innerHTML = markup;
      if (title) title.textContent = label || '';
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    gallery.querySelectorAll('[data-gallery-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        var src = button.getAttribute('data-gallery-src');
        if (!src) return;
        openLightbox('<img src="' + src + '" alt="">', button.getAttribute('data-gallery-title'));
      });
    });

    gallery.querySelectorAll('[data-gallery-video]').forEach(function (button) {
      button.addEventListener('click', function () {
        var raw = button.getAttribute('data-gallery-video') || '';
        var src = raw;
        if (raw.indexOf('youtube.com/watch') !== -1) {
          var match = raw.match(/[?&]v=([^&]+)/);
          if (match) src = 'https://www.youtube.com/embed/' + match[1] + '?autoplay=1';
        } else if (raw.indexOf('youtu.be/') !== -1) {
          src = 'https://www.youtube.com/embed/' + raw.split('youtu.be/')[1].split(/[?&]/)[0] + '?autoplay=1';
        } else if (raw.indexOf('vimeo.com/') !== -1) {
          src = 'https://player.vimeo.com/video/' + raw.split('vimeo.com/')[1].split(/[?&]/)[0] + '?autoplay=1';
        }
        openLightbox('<iframe src="' + src + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>', button.getAttribute('data-gallery-title'));
      });
    });

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      if (content) content.innerHTML = '';
      document.documentElement.style.overflow = '';
    }
    var close = gallery.querySelector('[data-gallery-close]');
    if (close) close.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
  });
});


// FsStudioFrance v1.2.0 — carrousel FAQ/Documentation par produit
document.addEventListener('DOMContentLoaded', function () {
 document.querySelectorAll('[data-fsf-product-support]').forEach(function(root){
  var slides=Array.from(root.querySelectorAll('[data-product-slide]')); if(!slides.length)return; var current=0;
  function select(i){ current=(i+slides.length)%slides.length; var key=slides[current].dataset.productSlide; slides.forEach(function(s,n){s.classList.toggle('is-active',n===current);}); root.querySelectorAll('[data-product-content]').forEach(function(el){el.hidden=el.dataset.productContent!==key;}); var active=slides[current]; if(active&&active.scrollIntoView){active.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});} }
  slides.forEach(function(s,i){s.addEventListener('click',function(){select(i);});}); var p=root.querySelector('[data-product-prev]'),n=root.querySelector('[data-product-next]'); if(p)p.addEventListener('click',function(){select(current-1)}); if(n)n.addEventListener('click',function(){select(current+1)}); select(0);
 });
});
